import React from "react";
import { Star } from "lucide-react";

export const SERVICE_OPTIONS = [
  { value: "general", label: "General" },
  { value: "mortgage-protection", label: "Mortgage Protection" },
  { value: "life-insurance", label: "Life Insurance" },
  { value: "final-expense", label: "Final Expense" },
  { value: "living-benefits", label: "Living Benefits" },
  { value: "retirement-wealth", label: "Retirement & Wealth" },
  { value: "career", label: "Career Opportunity" },
];

export const serviceLabel = (v) =>
  SERVICE_OPTIONS.find((s) => s.value === v)?.label || "General";

export function StarRow({ value = 5, size = 14, className = "" }) {
  return (
    <div className={`inline-flex items-center gap-1 ${className}`} aria-label={`${value} of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={i <= value ? "text-[#D4AF37] fill-[#D4AF37]" : "text-white/15"}
          style={{ width: size, height: size }}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}

export function StarPicker({ value, onChange, size = 28 }) {
  const [hover, setHover] = React.useState(0);
  return (
    <div className="inline-flex items-center gap-2" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`star-${i}`}
          onMouseEnter={() => setHover(i)}
          onMouseLeave={() => setHover(0)}
          onClick={() => onChange(i)}
          className="transition-transform hover:scale-110"
          aria-label={`${i} star${i > 1 ? "s" : ""}`}
        >
          <Star
            className={(hover || value) >= i ? "text-[#D4AF37] fill-[#D4AF37]" : "text-white/20"}
            style={{ width: size, height: size }}
            strokeWidth={1.25}
          />
        </button>
      ))}
    </div>
  );
}

export function formatLocation(r) {
  if (r.city && r.state) return `${r.city}, ${r.state}`;
  return r.city || r.state || null;
}
